var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenafiIcon = function SvgVenafiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6333",
    d: "M8.568 4.685a35.5 35.5 0 0 0 6.138 10.7l.899 1.053.91-1.052a35.7 35.7 0 0 0 6.157-10.7H19.62a30 30 0 0 1-3.983 7.049 29.5 29.5 0 0 1-3.973-7.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6333",
    d: "M20.921.032c-.073.178-.763 2.23-1.13 3.061h5.866a51.8 51.8 0 0 1-8.908 15.468l-1.306 1.557-1.307-1.557a51.8 51.8 0 0 1-8.908-15.5h5.583C10.445 2.232 9.765.18 9.68 0H.398a76 76 0 0 0 13.09 22.717L15.401 25l1.924-2.283A76.2 76.2 0 0 0 30.404 0z"
  })));
};
export default SvgVenafiIcon;